module.exports = __webpack_public_path__ + "static/media/agricultureicon.ce40ad4c.svg";